import _FormControlLabel from "@material-ui/core/esm/FormControlLabel";
import _Checkbox from "@material-ui/core/esm/Checkbox";
import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { checkboxBlockSelector } from '../../../../../redux/share-design/share-design.selectors';
import { checkboxBlockDispatcher } from '../../../../../redux/share-design/share-design.dispatchers';
import classes from './checkbox-block.scss';
const CheckboxBlock = props => {
  const {
    selectField,
    quantity,
    specs,
    descr,
    prodTime,
    price,
    isItemInBox,
    isLimitedEdition
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.checkboxBlockContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.checkboxItemContainer, {
      [classes.orangeCheckbox]: isLimitedEdition
    })
  }, /*#__PURE__*/React.createElement(_FormControlLabel, {
    label: "Product description",
    labelPlacement: "start",
    control: /*#__PURE__*/React.createElement(_Checkbox, {
      color: "primary",
      checked: descr,
      onChange: (event, checked) => selectField('descr', checked)
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.checkboxItemContainer, {
      [classes.orangeCheckbox]: isLimitedEdition
    })
  }, /*#__PURE__*/React.createElement(_FormControlLabel, {
    label: "Specs",
    labelPlacement: "start",
    control: /*#__PURE__*/React.createElement(_Checkbox, {
      color: "primary",
      checked: specs,
      onChange: (event, checked) => selectField('specs', checked)
    })
  })), !isItemInBox && /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.checkboxItemContainer, {
      [classes.orangeCheckbox]: isLimitedEdition
    })
  }, /*#__PURE__*/React.createElement(_FormControlLabel, {
    label: "Quantity",
    labelPlacement: "start",
    control: /*#__PURE__*/React.createElement(_Checkbox, {
      color: "primary",
      checked: quantity,
      onChange: (event, checked) => selectField('quantity', checked)
    })
  })), !isItemInBox && /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.checkboxItemContainer, {
      [classes.orangeCheckbox]: isLimitedEdition
    })
  }, /*#__PURE__*/React.createElement(_FormControlLabel, {
    label: "Production time",
    labelPlacement: "start",
    control: /*#__PURE__*/React.createElement(_Checkbox, {
      color: "primary",
      checked: prodTime,
      onChange: (event, checked) => selectField('prodTime', checked)
    })
  })), !isItemInBox && /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.checkboxItemContainer, {
      [classes.orangeCheckbox]: isLimitedEdition
    })
  }, /*#__PURE__*/React.createElement(_FormControlLabel, {
    label: "Price",
    labelPlacement: "start",
    control: /*#__PURE__*/React.createElement(_Checkbox, {
      color: "primary",
      checked: price,
      onChange: (event, checked) => selectField('price', checked)
    })
  })));
};
export default connect(checkboxBlockSelector, checkboxBlockDispatcher)(CheckboxBlock);